module.exports = __webpack_public_path__ + "static/img/gnmk_9@2x.1b60f624.png";